module.exports = __webpack_public_path__ + "static/media/edit_blue.d8d32a30.svg";